import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'

export const CHECK_FIELD = ['isAddBy1', 'isAddBy2', 'isAddBy3', 'carrier', 'frequency', 'polType', 'podType', 'freightType', 'vessel', 'voyageFlight']
/**
 * 运价输入审核
 */
export class FclApproveSettings {
  constructor(data) {
    this.freightType = ''
    this.polMap = {}
    this.podMap = {}
    this.isAddBy1 = true
    this.isAddBy2 = true
    this.isAddBy3 = true
    this.isAddByCost = true
    this.polType = 0
    this.podType = 0
    this.pol = ''
    this.col = ''
    this.rol = ''
    this.pod = ''
    this.cod = ''
    this.rod = ''
    this.carrier = 0
    this.frequency = 0
    this.one20 = 0
    this.one40 = 0
    this.oneHC = 0
    this.one20nor = 0
    this.one40nor = 0
    this.one45 = 0
    this.two20 = 0
    this.two40 = 0
    this.twoHC = 0
    this.two20nor = 0
    this.two40nor = 0
    this.two45 = 0
    this.three20 = 0
    this.three40 = 0
    this.threeHC = 0
    this.three20nor = 0
    this.three40nor = 0
    this.three45 = 0
    this.vessel = ''
    this.voyageFlight = ''
    this.polColumn = 'ALLRG'
    this.podColumn = 'ALLRG'
    this.setData(data)
  }
  setData(data) {
    if (data) {
      for (const item in data) {
        if (data.hasOwnProperty(item)) {
          this[item] = data[item]
        }
      }
    }
  }
  calcHashCode() {
    if (this.polType === 0) {
      this.hasCode(this.rol, this.polMap)
    } else if (this.polType === 1) {
      this.hasCode(this.col, this.polMap)
    } else {
      this.hasCode(this.pol, this.polMap)
    }
    if (this.podType === 0) {
      this.hasCode(this.rod, this.podMap)
    } else if (this.podType === 1) {
      this.hasCode(this.cod, this.podMap)
    } else {
      this.hasCode(this.pod, this.podMap)
    }
  }
  hasCode(field, map) {
    if (field) {
      const codes = field.split(',')
      for (const code of codes) {
        map[code] = true
      }
    }
  }
  isOverlap(other) {
    for (const key of CHECK_FIELD) {
      if (this[key] !== other[key]) return false
    }
    const polField = PriceUtils.getPolField(this.polType)
    const podField = PriceUtils.getPodField(this.podType)
    return PriceUtils.getOverlap(this[polField].split(','), other[polField].split(',')) &&
        PriceUtils.getOverlap(this[podField].split(','), other[podField].split(','))
  }
}
